import { connect } from 'react-redux';
import { updateAdminUser } from 'actions/users';
import Settings from 'components/settings/Settings';

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdate: (params) => {
      dispatch(updateAdminUser(params));
    },
  }
}

const SettingsContainer = connect(
  null,
  mapDispatchToProps
)(Settings)

export default SettingsContainer;
